import { IFiltrosDRE } from "@/features/financas/views/Indicadores/@types/type";
import PreferenciasTemplate from "../Preferencias/strategy/PreferenciasTemplate";
import { EWidgets } from "@/features/financas/views/Indicadores/@types/enums";

export default class PreferenciasDRE extends PreferenciasTemplate<IFiltrosDRE> {
  constructor() {
    super(EWidgets.DREPanel);
  }
}
